import { render, staticRenderFns } from "./mbzxBanKuai.vue?vue&type=template&id=9cd67bda&scoped=true"
import script from "./mbzxBanKuai.vue?vue&type=script&lang=js"
export * from "./mbzxBanKuai.vue?vue&type=script&lang=js"
import style0 from "./mbzxBanKuai.vue?vue&type=style&index=0&id=9cd67bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd67bda",
  null
  
)

export default component.exports